export default {
	api: 'https://ust-testing.beautitag.com/ldr/api',
	loginTimeout: 86400
};
